import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import styles from "./homepageValueProp.module.scss";

const valueProps = [
  {
    title: "home_value_title_1",
    subtitle: "home_value_subtitle_1",
    animationDelay: 50,
    cssClass: "customer-service",
  },
  {
    title: "home_value_title_2",
    subtitle: "home_value_subtitle_2",
    animationDelay: 150,
    cssClass: "free-shipping",
  },
  {
    title: "home_value_title_3",
    subtitle: "home_value_subtitle_3",
    animationDelay: 300,
    cssClass: "value-each-day",
  },
  {
    title: "home_value_title_4",
    subtitle: "home_value_subtitle_4",
    animationDelay: 400,
    cssClass: "selection",
  },
];

function HomepageValueProp() {
  const { t } = useTranslation("home");

  return (
    <div className={`section ${styles.home_page_value_props}`}>
      <PAText component="h2" fontSize={FONT_SIZE[5]} className={styles.home_page_value_title}>
        {t("Why Shop With Us")}
      </PAText>
      <div className={`${styles.image_container} row`}>
        {valueProps.map((item) => (

          <div className={`${styles.each_perk} text-center`} key={item.title} style={{ gap: "12px" }}>

            <div className={`img img-size ${item.cssClass}`} />

            <div className={styles.text_section}>

              <PAText component="h3" className={styles.value_text}>{t(item.title)}</PAText>

              <div className="subtitle">{t(item.subtitle)}</div>
            </div>
          </div>

        ))}
      </div>
    </div>
  );
}
export default HomepageValueProp;
